import React from "react";
import * as styles from "./popup-sheet-content-loading.module.scss";
import LoadingDots from "../loading-dots";
import { classArr } from "../../helper/style-helper";
import whitelabel from "../../whitelabel";

export interface PopupSheetContentLoadingProps {
	style?: React.CSSProperties;
	className?: string;
}

/**
 * A loading state component for popup sheet content
 */
export default function PopupSheetContentLoading(
	props: PopupSheetContentLoadingProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(styles.loading, props.className)}
		>
			<LoadingDots color={whitelabel.palette.secondary500} />
		</div>
	);
}
